import ShimmerLoading from './ShimmerLoading';

export default ShimmerLoading;
